import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=737792d7&"
import script from "./Agreement.vue?vue&type=script&lang=js&"
export * from "./Agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737792d7')) {
      api.createRecord('737792d7', component.options)
    } else {
      api.reload('737792d7', component.options)
    }
    module.hot.accept("./Agreement.vue?vue&type=template&id=737792d7&", function () {
      api.rerender('737792d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/auth/Agreement.vue"
export default component.exports